class BulkProductSelect extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.bulk-select__toggle');
    this.panel = this.querySelector('.bulk-select__panel');
    this.field = this.querySelector('input[type="hidden"]');
    this.label = this.querySelector('.bulk-select__label');
    this.count = this.querySelector('.bulk-select__count');
    this.chips = this.querySelector('.bulk-select__chips');
    this.error = this.querySelector('.bulk-select__error');
    this.boxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    this.form = this.closest('form');

    this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
    this.boxes.forEach((box) => box.addEventListener('change', () => this.update()));

    this.querySelector('[data-clear]')?.addEventListener('click', () => {
      this.boxes.forEach((box) => (box.checked = false));
      this.update();
    });
    this.querySelector('[data-done]')?.addEventListener('click', () => {
      this.setOpen(false);
      this.toggle.focus();
    });

    // Clicking a chip removes that product.
    this.chips.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-value]');
      if (!chip) return;
      const box = this.boxes.find((item) => item.value === chip.dataset.value);
      if (box) box.checked = false;
      this.update();
    });

    this.onDocClick = (event) => {
      if (!this.contains(event.target)) this.setOpen(false);
    };
    document.addEventListener('click', this.onDocClick);

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || this.panel.hidden) return;
      this.setOpen(false);
      this.toggle.focus();
    });

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        if (this.dataset.required !== 'true' || this.field.value) return;
        event.preventDefault();
        this.error.hidden = false;
        this.setOpen(true);
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
  }

  setOpen(open) {
    this.panel.hidden = !open;
    this.classList.toggle('is-open', open);
    this.toggle.setAttribute('aria-expanded', String(open));
  }

  update() {
    const picked = this.boxes.filter((box) => box.checked).map((box) => box.value);
    this.field.value = picked.join(', ');
    this.classList.toggle('has-value', picked.length > 0);

    this.label.textContent = picked.length
      ? `${picked.length} ${picked.length === 1 ? 'product' : 'products'} selected`
      : this.label.dataset.placeholder;
    this.count.hidden = picked.length === 0;
    this.count.textContent = picked.length;

    this.chips.replaceChildren(
      ...picked.map((value) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bulk-select__chip';
        chip.dataset.value = value;
        chip.setAttribute('aria-label', `Remove ${value}`);
        chip.innerHTML =
          '<span></span><svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 2l6 6M8 2 2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        chip.querySelector('span').textContent = value;
        return chip;
      })
    );

    if (picked.length) this.error.hidden = true;
  }
}

if (!customElements.get('bulk-product-select')) {
  customElements.define('bulk-product-select', BulkProductSelect);
}

// Pin code box: keep digits only, max 6.
document.addEventListener('input', (event) => {
  const input = event.target;
  if (!input.matches || !input.matches('[data-digits-only]')) return;
  const digits = input.value.replace(/\D/g, '').slice(0, 6);
  if (digits !== input.value) input.value = digits;
});
